import { useEffect, useRef, useState } from 'react'

const useInView = (threshold = 0.12) => {
  const ref = useRef(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.disconnect()
        }
      },
      { threshold }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [threshold])

  return [ref, isInView]
}

export const animClass = (isInView, animation = 'fadeInUp') =>
  isInView
    ? `animate__animated animate__${animation} animate__fast`
    : 'anim-hidden'

export default useInView
